import React, { FC } from 'react';

import { Chip, Stack, Typography } from 'components';

import { useTranslation } from 'third-party';

import { UNLIMITED_BANK_ACCOUNTS } from 'constants/common';

import { BillingPlan } from 'modules/billing';

type Props = {
  plan: BillingPlan;
  asChips?: boolean;
};

export const PlanFeatures: FC<Props> = ({ plan, asChips = false }) => {
  const { t } = useTranslation();

  const labels = [
    plan.includedChecksPerBank
      ? t('billing.plan.includedPerBank', { count: plan.includedChecks })
      : t('billing.plan.includedPerMonth', { count: plan.includedChecks }),
    plan.maxBankAccounts === UNLIMITED_BANK_ACCOUNTS
      ? t('billing.plan.banksUnlimited')
      : t('billing.plan.banks', { count: plan.maxBankAccounts }),
    plan.hasCheckDesigner ? t('billing.plan.feature.checkDesigner') : null,
    plan.hasCustomEmailTemplates
      ? t('billing.plan.feature.emailTemplates')
      : null,
    plan.hasApiAccess ? t('billing.plan.feature.apiAccess') : null,
    plan.hasPrioritySupport ? t('billing.plan.feature.prioritySupport') : null,
    plan.showBadge ? t('billing.plan.feature.badge') : null,
  ].filter(Boolean);

  if (asChips) {
    return (
      <Stack direction="row" flexWrap="wrap" spacing={1} useFlexGap>
        {labels.map(label => (
          <Chip key={label} size="small" variant="outlined" label={label} />
        ))}
      </Stack>
    );
  }

  return (
    <Stack spacing={0.5}>
      {labels.map(label => (
        <Typography key={label} variant="body2" color="text.secondary">
          {label}
        </Typography>
      ))}
    </Stack>
  );
};
